// components
import KryptoKeeper from './components/Kryptokeeper';
import './styles/styles.css';

function App() {

  return (
    <div className="App">
      <KryptoKeeper />
    </div>
  );
}

export default App;